<template>
  <div class="Statistic">
    <el-tabs style="margin-top:0px 20px;" type="card" @tab-click="handleSelect" v-model="activeName" >
        <el-tab-pane label="个人统计" name="first"></el-tab-pane>
        <el-tab-pane label="科室统计" name="second"></el-tab-pane>
        <el-tab-pane label="阳性率统计" name="third"></el-tab-pane>
        <personStatistic v-if='activeName === "first"'></personStatistic>
        <departStatistic v-if='activeName === "second"'></departStatistic>
        <selfDepartPositiveRate v-if='activeName === "third"'></selfDepartPositiveRate>
    </el-tabs>
  </div>
</template>
<script>
import personStatistic from './personStatistic'
import departStatistic from './departStatistic'
import selfDepartPositiveRate from './selfDepartPositiveRate'

export default {
  name: 'Registration',
  data() {
    return {
      activeName: 'first',
      isperson: true,
      depart: false
    }
  },
  components: {
    departStatistic,
    personStatistic,
    selfDepartPositiveRate
  },
  created() {
  },
  methods: {
    handleSelect(tab, event) {
      if (tab.name === 'first') {
        this.isperson = true
      }
    }
  }
}
</script>
<style  rel='stylesheet/scss' lang='scss' scoped>
  .Statistic {
    height: 100%;
    overflow-y: auto;
    .el-tabs {
      padding: 0px 20px;
      margin-top: 20px;
    }
  }
</style>
